var EventListApp = (function ($) {
    'use strict';

    //#region Variables
    var eventListApp = document.getElementById('ngEventsListApp');
    //var culture = eventListApp.getAttribute("data-culture");
    var year = '0';
    var month = '0';
    var type = '';
    var page = '0';
    var years = [];
    var events = [];
    var calendar = {};
    var eventTypes = {};

    var monthNames = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];
    //#endregion

    function init() {
        var date = new Date();
        getCalendar(date.getFullYear(), date.getMonth());
        getList("0", "0", "", "0");
        getEventTypes();
        getEventYearRange();

        $("#selectMonth").change(function () {
            var sMonth = parseInt(this.value);
            var sYear = parseInt($("#selectYear").val());
            getList(sYear, sMonth, "", "0");
        });
        $("#selectYear").change(function () {
            var sYear = parseInt(this.value);
            var sMonth = parseInt($("#selectMonth").val());
            getList(sYear, sMonth, "", "0");
        });


    }

    //#region Functions
    function getList(year, month, type, page) {
        var params = {
            "year": year,
            "month": month,
            "type": type,
            "page": page
        };

        EventList_Svc.GetUpcomingEvents(params);
    }
    function getCalendar(year, month) {
        var params = {
            "year": year,
            "month": month + 1
        };

        EventList_Svc.GetCalendarEvents(params);
    }
    function getEventTypes() {
        EventList_Svc.GetEventTypes();
    }
    function getEventYearRange() {
        EventList_Svc.GetEventYearRange();
    }
    function refreshList(eventsData, year, month, type, page) {
        year = year;
        month = month;
        type = type;
        page = page;
        events = [];

        for (var key in eventsData) {
            events.push(eventsData[key]);
        }
        if (events.length > 0) {

            $('#list_noevents').hide();
            $(".list-view__event").empty();
        } else {
            $(".list-view__event").empty();
            $('#list_noevents').show();
        }

        for (var i = 0; i < events.length; i++) {
            var event = events[i];
            $(".list-view__event").append(generateHtml(event));
        }

    }
    function refreshCalendar(events, year, month) {
        calendar.year = year;
        calendar.month = month;
        calendar.monthName = monthNames[month];
        calendar.weeks = {};
        calendar.weeks[0] = {};
        calendar.weeks[0].days = {};
        calendar.classes = "";

        var startDayOfWeek = new Date(year, month, 1).getDay();
        var weekNum = 0;
        var dayOfWeekNum = 0;
        var dateNum = 1;
        var lastDateNum = new Date(year, month + 1, 0).getDate();

        for (var i = 0; i < startDayOfWeek; i++) {
            calendar.weeks[weekNum].days[dayOfWeekNum] = {
                label: ""
            };
            dayOfWeekNum++;
        }

        for (dateNum; dateNum <= lastDateNum; dateNum++) {
            calendar.weeks[weekNum].days[dayOfWeekNum] = {
                label: dateNum,
                events: getEvents(events, year, month, dateNum)
            };

            if (calendar.weeks[weekNum].days[dayOfWeekNum].events.length) {
                calendar.classes = "has-events";
                calendar.weeks[weekNum].days[dayOfWeekNum].classes = "has-events";
            }

            var today = new Date();
            if (today.getDate() === dateNum && today.getMonth() === month && today.getFullYear() === year) {
                calendar.weeks[weekNum].days[dayOfWeekNum].classes += " is-today";
            }

            dayOfWeekNum++;

            if (dayOfWeekNum > 6) {
                dayOfWeekNum = 0;
                weekNum++;
                calendar.weeks[weekNum] = {};
                calendar.weeks[weekNum].days = {};
            }
        }

        for (dayOfWeekNum; dayOfWeekNum !== 0 && dayOfWeekNum <= 6; dayOfWeekNum++) {
            calendar.weeks[weekNum].days[dayOfWeekNum] = {
                label: ""
            };
        }
        $('.calendar-view-month-title').text(calendar.monthName + ' ' + calendar.year);


        var htmlTotalCode = '';
        $.each(calendar.weeks, function (key, value) {
            var week = value;
            var htmlDayCode = '';

            $.each(week.days, function (key, value) {
                var day = value;

                var htmlEventCode = '';
                $.each(day.events, function (key, value) {
                    var event = value;

                    htmlEventCode += `<div class="calendar-view__event">
              <a href="${event.DetailsURL}">${event.Name}</a>
            </div>`;
                });
                htmlDayCode += `<div class="calendar-view__day ${day.classes}">
          <div class="calendar-view__label">${day.label}</div>
          ${htmlEventCode}
        </div>`;
            });

            htmlTotalCode += `
            <div class="calendar-view__week">
              ${htmlDayCode}
            </div>
          `;
        });

        $('.calendar-view__weeks').html(htmlTotalCode);
    }
    function getEvents(events, year, month, day) {
        var startDateTime = new Date(year, month, day, 0, 0, 0, 0);
        var endDateTime = new Date(year, month, day, 23, 59, 59, 999);
        var filteredEvents = [];
        for (var key in events) {
            if (new Date(events[key].StartDate) <= endDateTime && new Date(events[key].EndDate) >= startDateTime) {
                filteredEvents.push(events[key]);
            }
        }
        return filteredEvents;
    }
    function updateList() {
        getList(year, month, type, page);
    };

    function previousCalendar() {
        calendar.month--;
        if (calendar.month === -1) {
            calendar.month = 11;
            calendar.year--;
        }

        getCalendar(calendar.year, calendar.month);
    };

    function nextCalendar() {
        calendar.month++;
        if (calendar.month === 12) {
            calendar.month = 0;
            calendar.year++;
        }
        getCalendar(calendar.year, calendar.month);
    };

    var EventList_Svc = {
        GetUpcomingEvents: function (params) {
            $.ajax({
                url: "/EventsAPI/Events/GetUpcomingEvents",
                type: "GET",
                data: params,
                contentType: "application/json"
            }).done(function (result) {
                var resultsData = result;
                refreshList(resultsData, params.year, params.month, type, page);
            });

        },
        GetCalendarEvents: function (params) {
            $.ajax({
                url: "/EventsAPI/Events/GetCalendarEvents",
                type: "GET",
                data: params,
                contentType: "application/json"
            })
                .done(function (result) {
                    var resultsData = result;
                    refreshCalendar(resultsData, params.year, params.month - 1);
                });
        },
        GetEventTypes: function () {
            $.ajax({
                url: "/EventsAPI/Events/GetEventTypes",
                type: "GET",
                contentType: "application/json"
            })
                .done(function (result) {
                    eventTypes = result;
                    if (eventTypes != undefined && eventTypes != null && eventTypes.length > 0) {
                        var selectEventType = $("#selectEventType");
                        $.each(eventTypes, function (index, item) {
                            selectEventType.append($('<option>', {
                                value: item.Name,
                                text: item.Name
                            }));
                        });
                        $("#lblEventType").show();
                        $("#selectEventType").show();
                    }
                    else {
                        $("#lblEventType").hide();
                        $("#selectEventType").hide();
                    }
                });
        },
        GetEventYearRange: function () {
            $.ajax({
                url: "/EventsAPI/Events/GetEventYearRange",
                type: "GET",
                contentType: "application/json"
            })
                .done(function (result) {
                    var resultsData = result;
                    if (resultsData) {
                        years = [];
                        for (var i = resultsData.MinYear; i <= resultsData.MaxYear; i++) {
                            years.push(i);
                        }
                        var selectYear = $("#selectYear");
                        $.each(years, function (index, year) {
                            selectYear.append($('<option>', {
                                value: year,
                                text: year
                            }));
                        });
                    }
                });
        }
    };
    function generateHtml(event) {
        var eventItem = event;
        var listViewEventHTML = "";
        if (eventItem != undefined && eventItem != null) {
            let startDate = new Date(event.StartDate);
            let endDate = new Date(event.EndDate);
            let startDateFormat = startDate.toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            });
            let endDateFormat = endDate.toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            });
            listViewEventHTML = `
                <div class="row">
                    <div class="col-md-5">
                        <h2>${event.Name}</h2>
                        <div class="event-date">${startDateFormat} - ${endDateFormat}</div>
                        <div class="event-location"><span class="fas fa-map-marker-alt" aria-hidden="true"></span> ${event.Address}</div>
                        <div>${event.Summary}</div>
                    </div>
                    <div class="col-md-4">${event.Image ? `<img src="${event.Image}" class="event-image card" alt="" />` : ''}</div>
                    <div class="col-md-3">
                        <a href="${event.DetailsURL}" class="btn primary-button" aria-label="Event details for ${event.Name}">Event Details</a>
                        ${event.RegisterURL ? `<a href="${event.RegisterURL}" class="btn btn-secondary" aria-label="Register for ${event.Name}">Register</a>` : ''}
                    </div>
                </div>`;
        }

        return listViewEventHTML;
    }
    //#endregion

    return {
        init: init,
        nextCalendar: nextCalendar,
        previousCalendar: previousCalendar
    };
})(jQuery);

$(function () {
    EventListApp.init();
});